import { UncontrolledButtonDropdown as ButtonDropdown } from "reactstrap";

export const MissingInformationDropdown = ({ substatuses, updateRequestStatusPath }) => {
  const setUpdatePath = (key) => {
    return updateRequestStatusPath.replace("__key__", key);
  };

  return (
    <ButtonDropdown className="missing-info me-2">
      <button
        type="button"
        className="btn btn-warning dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Missing Information
      </button>

      <div className="dropdown-menu">
        {Object.entries(substatuses).map(([key, substatus]) => {
          return (
            <a href={setUpdatePath(key)} key={key} className="dropdown-item" rel="nofollow" data-method="post">
              {substatus.name}
            </a>
          );
        })}
      </div>
    </ButtonDropdown>
  );
};
